import Rails from '@rails/ujs';

export function growlError(message, timeout = 4000) {
  const alertHTML = `
    <div class="alert alert-danger alert-growl">
      <span aria-hidden="true" class="alert-hide" data-dismiss="alert" style="margin-left:10px;">×</span>
      <i class="fa fa-exclamation-circle margin-right-10"></i>
      ${message}
    </div>`;

  document.body.insertAdjacentHTML('beforeend', alertHTML);

  setTimeout(function () {
    document.querySelectorAll('.alert-growl').forEach((el) => el.remove());
  }, timeout);
}

function verifyCaptchaBeforeSubmit(form) {
  form.addEventListener('ajax:before', (event) => {
    if (typeof hcaptcha !== 'undefined' && hcaptcha.getResponse() === '') {
      event.preventDefault();
      const response = hcaptcha.execute(null, { async: true });
      if (response) {
        response
          .then(() => Rails.handleRemote.call(form, event))
          .catch(() => hcaptcha.reset());
      }
    }
  });
}

export function setupAuthForm(selector, { onSuccess = null, onError }) {
  function handleForm() {
    const form = document.querySelector(selector);
    if (!form) return;

    verifyCaptchaBeforeSubmit(form);

    if (onSuccess) {
      form.addEventListener('ajax:success', onSuccess);
    }

    form.addEventListener('ajax:error', (event: CustomEvent) => {
      const xhr = event.detail[event.detail.length - 1];
      if (typeof hcaptcha !== 'undefined') {
        hcaptcha.reset();
      }
      onError(xhr);
    });
  }

  document.addEventListener('turbolinks:load', handleForm);
  document.addEventListener('ajax:success', handleForm);
}
